module.exports = __webpack_public_path__ + "img/icon_identity_card3.d74bf636.png";